import axios from 'axios';
import { API_URL } from '../env';

/** Emails a reset link to the address, if it has an account (the answer is the same either way). */
export const forgotPassword = async ({ email }) => {
  const response = await axios.post(`${API_URL}/password/forgot`, { email });
  return response.data;
};

/** Sets a new password with the token from the emailed link. */
export const resetPassword = async (body) => {
  const response = await axios.post(`${API_URL}/password/reset`, body);
  return response.data;
};
